module.exports = __webpack_public_path__ + "img/cpzz8@2x.ce75f198.png";